<h1 mat-dialog-title>Gestionar Columnas</h1>
<div mat-dialog-content>
  <p>Seleccione las columnas a mostrar y arrástrelas para reordenarlas.</p>
  <cdk-drop-list (cdkDropListDropped)="drop($event)">
    <mat-list-item *ngFor="let column of columns" cdkDrag>
      <div class="flex items-center w-full">
        <mat-icon cdkDragHandle class="drag-handle">drag_indicator</mat-icon>
        <mat-checkbox [(ngModel)]="column.checked" class="example-box">
          {{ column.label || column.key }}
        </mat-checkbox>
      </div>
    </mat-list-item>
  </cdk-drop-list>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-button color="primary" (click)="onAccept()">Aceptar</button>
</div>
